import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { NeuralToastProvider } from "./providers/NeuralToastProvider";
import { Web3Provider } from "./providers/Web3Provider";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Web3Provider>
      <NeuralToastProvider>
        <App />
      </NeuralToastProvider>
    </Web3Provider>
  </StrictMode>
);
